module.exports = __webpack_public_path__ + "img/privilege_2_img1.17fe3938.png";